module.exports = __webpack_public_path__ + "img/4.2b7ecd4a.jpg";